<template>
    <el-main class="list-container">
      <el-row type="flex" justify="center" class="list-header">
        <el-col :span="12" class="section-header">
          <span class="section-title">Portafolios</span>
        </el-col>
        <el-col :span="10">
          <div class="new-portfolio" v-on:click="goToNewPortfolioForm"><i class="el-icon-plus"></i>Nuevo portafolio</div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="22">
          <el-table v-loading="loading" empty-text="Sin resultados" :data="portfolios" style="width: 100%" @cell-click="goToPortfolio" :cell-class-name="setStatusStyles">
          <el-table-column prop="client.alias" label="Alias"></el-table-column>
          <el-table-column prop="contractNumber" label="No. de portafolio"></el-table-column>
          <el-table-column prop="createdAt" label="Fecha"></el-table-column>
          <el-table-column prop="version" label="Versión"></el-table-column>
          <el-table-column prop="status" label="Estatus"></el-table-column>
          <el-table-column  width="60">
            <template slot-scope="scope">
              <el-dropdown trigger="click" placement="top">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.status === 'En progreso'" v-on:click.native="continueDraft(scope.row.id)">Continuar</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status !== 'En progreso'" v-on:click.native="editPortfolio(scope.row.id)">Editar</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status !== 'En progreso'" v-on:click.native="updatePortfolio(scope.row.id)">Actualizar</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status !== 'En progreso' && userIsAdmin" v-on:click.native="commentPortfolio(scope.row.id)">Comentar</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status !== 'En progreso'" v-on:click.native="sendUrl(scope.row)">Enviar enlace</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status !== 'En progreso'" v-on:click.native="deletePortfolio(scope.row.id)"><span class="danger">Eliminar</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        </el-col>
      </el-row>
      <!-- Dialog send url -->
      <el-dialog title="Enviar enlace" class="send-url-container" :visible.sync="displaySendUrlDialog">
        <div>
          <el-form :model="sendUrlData" status-icon :rules="rules" ref="sendShareUrl">
            <span> Email </span>
            <el-form-item prop="email">
              <el-input class="send-url" placeholder="" prefix-icon="el-icon-edit" v-model="sendUrlData.email" auto-complete="off"></el-input>
            </el-form-item>
            <el-button type="primary" v-on:click="validateAndSumbit('sendShareUrl')" style="width:100%; background-color:#2873DE; border:none">Enviar</el-button>
          </el-form>
        </div>
      </el-dialog>
    </el-main>
</template>

<script>
import { getPortfoliosByAdvisorId, getAllPortfolios, sendUrl, upgradePortfolio,
  getPortfolioById, getAdvisorData, deletePortfolio} from '@/graphql'

export default {
  name: 'Portfolios',
  data () {
    return {
      loading: true,
      displaySendUrlDialog: false,
      sendUrlData: {
          email: '',
          portfolioId: 0
      },
      rules: {
        email: [
          {
            required: true,
            message: "Debes proporcionar un email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Es necesario un email válido, ejemplo@email.com",
            trigger: "blur"
          }
        ]
      }
    }
  },
  created() {
    const userId = localStorage.getItem('user_id')
    if (!this.advisorId) {
      this.$apollo.query({query: getAdvisorData,
      variables: {id: userId },
      fetchPolicy: 'cache-first'})
      .then((data) => this.$store.dispatch( 'saveUserData', data.data))
    }
  },
  computed: {
    advisoryQuery: function () {
      return {
        query: getPortfoliosByAdvisorId,
        variables: {
          advisorId: this.advisorId
        },
        fetchPolicy: 'network-only'
      }
    },
    adminQuery: function () {
     return {
       query: getAllPortfolios,
       fetchPolicy: 'network-only'
     }
    },
    userIsAdmin: function () {
      return this.$store.getters.userIsAdmin
    },
    advisorId: function () {
      return this.$store.getters.userInfo.id
    },
    portfolios: function () {
      return this.$store.getters.portfoliosData
    }
  },
  watch: {
    advisorId: function (value) {
      // console.log("USER HAS CHANGED", value)
      this.getPortfolios();
    }
  },
  mounted () {
    this.getPortfolios();
  },
  methods: {
    getPortfolios () {
      // console.log("Loading portfolios", this.userIsAdmin, this.advisorId)
      if (this.advisorId) {
        const q = this.userIsAdmin ? this.adminQuery : this.advisoryQuery
        this.$apollo.query({
          query: q.query,
          variables: q.variables,
          fetchPolicy: q.fetchPolicy
        })
        .then((data) => {
          this.successHandler(data.data)
        })
        .catch((error) => { console.log(error) })
      }
    },
    goToNewPortfolioForm () {
      this.$store.dispatch('resetPortfolioForm')
      this.$store.dispatch('setFormMode', 1)
      this.$router.push('/registro-datos-generales')
    },
    setStatusStyles ({row, columnIndex}) {
     if (columnIndex === 4 && row.status == 'Listo') {
       return 'ready'
     } else if (columnIndex === 4 && row.status == 'En progreso'){
       return 'in-progress'
     } else if (columnIndex === 4 && row.status == 'Comentado'){
       return 'commented'
     }
    },
    successHandler(data) {
      this.loading = false
      this.$store.dispatch( 'savePortfolios',
      this.userIsAdmin ? data.allPortfolios : data.portfoliosByAdvisor )
    },
    goToPortfolio (row, column, cell, event) {
      if (column.property && row.status !== 'En progreso') {
        const portfolioId = row.id
        this.$router.push(`analisis-portafolio/${portfolioId}`)
      }
    },
    continueDraft(id) {
      this.$store.dispatch('setSelectedPortfolio', id)
      this.$store.dispatch('setFormMode', 2)
      this.$apollo.query({
        query: getPortfolioById,
        variables: {id},
        fetchPolicy: 'network-only'
      }).then(data => this.redirectToForm(data.data.portfolioById))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      })
    },
    editPortfolio (id) {
      this.$store.dispatch('setFormMode', 3)
      this.$store.dispatch('setSelectedPortfolio', id)
      this.$apollo.query({
        query: getPortfolioById,
        variables: {id},
        fetchPolicy: 'network-only'
      }).then(data => this.redirectToForm(data.data.portfolioById))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      })
    },
    redirectToForm (portfolio) {
      this.$store.dispatch("preloadPortfolioForm", portfolio)
      this.$router.push('/registro-datos-generales')
    },
    updatePortfolio (portfolioId) {
      this.$apollo.mutate({ mutation: upgradePortfolio,
        variables: {portfolioId}
      }).then(data => this.requestSuccess(data.data.upgradePortfolio.message))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    commentPortfolio(portfolioId) {
      this.$router.push(`analisis-portafolio/${portfolioId}`)
    },
    validateAndSumbit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.displaySendUrlDialog = false
          this.sendUrlRequest(this.sendUrlData)
        } else {
          return false;
        }
      })
    },
    sendUrlRequest(data) {
      this.$apollo.query({ query: sendUrl,
        variables: {
          portfolioId: data.portfolioId,
          email: data.email
        }
      })
      .then(data => this.requestSuccess(data.data.sendAnalysisUrl.msg))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error, intenta más tarde"
        });
      });
    },
    showSendUrlDialog (portfolioId) {
      this.sendUrlData.portfolioId = portfolioId
      this.displaySendUrlDialog = true
    },
    sendUrl(portfolioData) {
      const portfolioId = portfolioData.id
      const clientEmail = portfolioData.client.email
      if (clientEmail) {
        this.$apollo.query({ query: sendUrl,
          variables: {
            portfolioId: portfolioId,
            email: clientEmail
          }
        })
        .then(data => this.requestSuccess(data.data.sendAnalysisUrl.msg))
        .catch(() => {
          this.$message({
            type: "error",
            message: "Ocurrió un error intenta más tarde"
          });
        });
      } else {
        this.showSendUrlDialog(portfolioId)
      }
    },
    requestSuccess(message) {
      this.$message({type: "success", message})
    },
    deleteRequestSuccess() {
      this.getPortfolios();
      this.$message({type: "success", message: "Se borró el portafolio efectivamente"});
      // console.log("YESS")
    },
    deletePortfolio(portfolioId) {
      this.$confirm(
        "¿Deseas borrar el portafolio? Se borrará permanentemente.",
        "Borrar portafolio",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          this.doDeletePortfolio(portfolioId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada"
          });
        });
    },
    doDeletePortfolio(portfolioId) {
      this.$apollo
        .mutate({
          mutation: deletePortfolio,
          variables: {
            portfolioId
          }
        })
        .then(data => this.deleteRequestSuccess())
        .catch(() => {
          this.$message({
            type: "error",
            message: "Ocurrió un error, por favor intenta más tarde o contacta al admin"
          });
        });
    }
  }
};
</script>

<!-- Component styles if required -->
<style scoped>

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.el-dialog  {
  text-align: left;
}

.section-header {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  padding: 10px;

}

.section-title {
  font-size: 18px;
  font-weight: 600;
}

.new-portfolio {
  cursor: pointer;
  background-color: #2873DE;
  border-radius: 3px;
  color: white;
  width: 180px;
  float: right;
  padding: 9px 10px;
  font-size: 16px;
  text-decoration: none;
}

.new-portfolio:active {
  background-color: #F5F5F5;
  outline: none;
}

.list-header {
  margin: 25px 0 38px 0;
}

.el-icon-plus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 20px;
}

.el-table {
  font-size: 16px;
  text-align: left;
}
.danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ListPortfolios.vue